import EventEmitter from 'eventemitter3';
export class ViewModelBase{
    emitter:EventEmitter = new EventEmitter();
}